<!-- 项目文件 -->
<template>
    <div class="posre">
        <Header1 :img="bgImg"></Header1>
        <div class="w100p bgfff">
            <div class="pt30 pb20 w1200 mauto">
                <div class="pt20 pb20 textc  border2 mauto">
                    <p class="fs20 c333 disinblock"> {{news.Title}} </p>
                    <p class="fs14 c666 pt10 pb10">
                        <span class="fs14 c666 mr10"> 发布时间 : {{news.Time | formatDate}} </span>
            
                    </p>
                </div>
                <div class="pt15 pb15" v-html="news.Detail">
                </div>
            </div>
        </div>
    
    <Footer></Footer>
    </div>
</template>

<script>
    import Header1 from '@/components/Header1'
    import Footer from '@/components/Footer'
    import $ from "jquery";
    export default {
        data() {
            return {
                bgImg: require('../../public/img/img165.png'),
                news: {
                    Detail: '',
                    Title: '',

                    Time: '',
                },
                Area_idX: ''
            };
        },
        components: {
            Header1,
            Footer,
        },
        mounted() {

        },
        methods: {
            getComNews() {
                let that = this;
                that.news = that.$store.state.CompanynewsDetail;
                that.Area_idX = that.$route.query.cityid;
                for (let i = 0; i < that.news.length; i++) {
                    if (that.news[i].id == that.$route.query.news_id) {
                        that.news.Detail = that.news[i].content;
                        that.news.Title = that.news[i].title;

                        that.news.Time = that.news[i].create_time;
                    }

                }
                console.log(that.news)
            }


        },

        filters: {
            formatDate(value) {
                var d = new Date(parseInt(value) * 1000);
                return (d.getFullYear()) + '-' + (d.getMonth() + 1 > 9 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)) + '-' +
                    (d.getDate() > 9 ? d.getDate() : '0' + d.getDate());
            }
        },
        created() {
            this.getComNews()
        },
    }
</script>
<style scoped>

</style>